import React, { Children, useState } from "react";
import { Form, InputNumber, Popover, theme } from "antd";
import { URL_TRUCK } from "../../constants/urls";
import { POST } from "../../frameworks/HttpClient";
import ColorButton from "../../common/ColorButton";

export default function ReceivingWeightPopover(props){
  const {target, direction, onUpdate, children} = props;
  const [form] = Form.useForm(); 
  const [visible, setVisible] = React.useState(false);
  const [ errorMessages , setErrorMessages] = useState(null);
  // ฟังก์ชันเปิด/ปิด Popover
  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };


  const handleOK = async() => {
    try {
      const data = await form.validateFields();
      data["truck_transaction"] = target;
      data["direction"] = direction;
      await POST(URL_TRUCK.TRUCK_TRANSACTION_WEIGHT, data);
      onUpdate();
      setVisible(false); 
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  }

  const { token : { colorWarning }} = theme.useToken();

  return (
    <Popover 
      title={<center>{direction === 'in' ? "ชั่งน้ำหนักเข้า" : "ชั่งน้ำหนักออก"}</center>}
      trigger="click"
      open={visible}
      onOpenChange={handleVisibleChange}
      style={{ padding : 5} }
      content={ 
        <Form
          form={form}
          layout={'vertical'}
          style={{ width: "100%"}}
          autoComplete="off">
            <Form.Item
              name={"weight"}
              style={{ alignItems: 'center',  justifyContent: 'center', display: 'flex' }}
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}>
                <InputNumber autoComplete="off" style={{ width: 300 }} placeholder="น้ำหนัก" addonBefore="น้ำหนัก" addonAfter="kg." onPressEnter={() => handleOK()}/>
            </Form.Item>
            <Form.Item>
              <ColorButton type={"primary"} override={colorWarning} onClick={handleOK} style={{ float : 'right'}}>ยืนยัน</ColorButton>
              <ColorButton onClick={() => setVisible(false)} style={{ float : 'right', marginRight : 5 }}>ปิด</ColorButton>
            </Form.Item>
        </Form>
      }
    >
      {children}
    </Popover>
  )
}